var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup45(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#233155;}.c,.d{stroke:none;}.d{fill:#233155;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 -348)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(6027 461)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-5991-104a9,9,0,0,1,9-9,9,9,0,0,1,9,9,9,9,0,0,1-9,9,9,9,0,0,1-2.614-.386L-5991-89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M -5982 -111.0002670288086 C -5985.85986328125 -111.0002670288086 -5989.00048828125 -107.8599853515625 -5989.00048828125 -104.0000610351562 L -5989.00048828125 -93.82839965820312 L -5986.0283203125 -96.79991912841797 L -5985.1806640625 -97.64720153808594 L -5984.0341796875 -97.29953002929688 C -5983.3779296875 -97.10067749023438 -5982.69384765625 -96.99985504150391 -5982 -96.99985504150391 C -5978.14013671875 -96.99985504150391 -5975 -100.14013671875 -5975 -104.0000610351562 C -5975 -107.8599853515625 -5978.14013671875 -111.0002670288086 -5982 -111.0002670288086 M -5982 -113.0002670288086 C -5977.029296875 -113.0002670288086 -5973 -108.9707717895508 -5973 -104.0000610351562 C -5973 -99.02935028076172 -5977.029296875 -94.99985504150391 -5982 -94.99985504150391 C -5982.90966796875 -94.99985504150391 -5983.787109375 -95.13478851318359 -5984.6142578125 -95.38555145263672 L -5991.00048828125 -89.00071716308594 L -5991.00048828125 -104.0000610351562 C -5991.00048828125 -108.9707717895508 -5986.970703125 -113.0002670288086 -5982 -113.0002670288086 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2,
    height: 6,
    transform: "translate(44 352)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2,
    height: 3,
    transform: "translate(46 358) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 13,
    height: 2,
    transform: "translate(32 348)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 3,
    height: 2,
    transform: "translate(32 360)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 6,
    height: 2,
    transform: "translate(32 352)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2,
    height: 2,
    transform: "translate(32 364)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4,
    height: 2,
    transform: "translate(32 356)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup45);
export default __webpack_public_path__ + "static/media/Group 45.d7610249927578e2c86b29faa86ed9c1.svg";
export { ForwardRef as ReactComponent };